import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { State, Action, StateContext } from '@ngxs/store';
import * as BLSActions from './branchline.actions';
import { utils } from 'src/app/modules/libs/utils';
import { IResource } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourcesService } from 'src/app/components/catalogs/beamline-catalog/resource/resources.service';
import { readStatusSnapshot, writeStatusSnapshot } from '../../status-snapshot-cache';

const BRANCHLINE_STATUS_SNAPSHOT_KEY = 'home:branchline-status:snapshot';

export interface BranchlineStatusStateModel {
  data: IResource[];
  loading: boolean;
  // Cached values do not mark the live startup refresh complete.
  loaded: boolean;
}

@State<BranchlineStatusStateModel>({
  name: 'Branchlines',
  defaults: {
    data: [],
    loading: false,
    loaded: false,
  }
})

@Injectable()
export class BranchlineStatusState extends BaseState {
  constructor(
    protected override injector: Injector, public resourcesService: ResourcesService
  ) {
    super(injector);
  }

  @Action(BLSActions.Refresh)
  RefreshBranchStatus(ctx: StateContext<BranchlineStatusStateModel>) {
    ctx.patchState({ loading: true, loaded: false });

    if (!ctx.getState().data?.length) {
      const snapshot = readStatusSnapshot<IResource[]>(BRANCHLINE_STATUS_SNAPSHOT_KEY);
      if (snapshot?.length) ctx.patchState({ data: snapshot });
    }

    this.resourcesService.getBranchlines().subscribe(result => {

      result = result.sort((a, b) => utils.sortArrayAlphabeticallyWithComplexNumbers(a.name, b.name));
      result.map(r => {
        r.moreInfo = r.documents?.join(', ');
      });
      ctx.patchState({ data: result, loading: false, loaded: true });
      writeStatusSnapshot(BRANCHLINE_STATUS_SNAPSHOT_KEY, result);
    }, error => {
      ctx.patchState({ loading: false });
      console.error(error);
    });
  }

  @Action(BLSActions.Update)
  UpdateBranchStatus(ctx: StateContext<BranchlineStatusStateModel>, { payload }: BLSActions.Update) {
    const state = ctx.getState();
    const data = utils.cloneDeep(state.data);
    const index = data.findIndex(val => val.id === payload.id);
    payload.moreInfo = payload.documents?.join(', ');
    data.splice(index, 1, payload);
    ctx.patchState({ data });
  }

  @Action(BLSActions.Add)
  AddBranchStatus(ctx: StateContext<BranchlineStatusStateModel>, { payload }: BLSActions.Add) {
    const state = ctx.getState();
    let data = utils.cloneDeep(state.data);
    payload.moreInfo = payload.documents?.join('');
    data.splice(0, 0, payload);
    data = data.sort((a, b) => utils.SortBeamlines(a.name, b.name));
    ctx.patchState({ data });
  }

  @Action(BLSActions.Delete)
  DeleteBranchStatus(ctx: StateContext<BranchlineStatusStateModel>, { payload }: BLSActions.Delete) {
    const state = ctx.getState();
    const data = utils.cloneDeep(state.data);
    const index = data.findIndex(val => val.id === payload);
    data.splice(index, 1);
    ctx.patchState({ data });
  }

}
